import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ENTITLEMENTS } from '../../application-core/constants';
import SlatInner from '../../core/SlatInner';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkResourceEntitlements } from '../../core/utils/utils';

class CollectionConceptSlat extends React.Component {

    state = {
        active: false
    };

    setActive(isActive) {
        this.setState({ active: isActive });
    }

    render() {

        const { data, onSelect, classes, onBreakLink, defaultLang, viewLang, activeConcept } = this.props;
        const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_TAXONOMY);

        let label = data.id;
        const displayLang = viewLang && data.prefLabel && data.prefLabel[viewLang] ?
            viewLang
            :
            data.prefLabel && data.prefLabel[defaultLang] ?
                defaultLang
                :
                "und";

        if (data.prefLabel && data.prefLabel[displayLang]) {
            label = Array.isArray(data.prefLabel[displayLang]) ?
                [...data.prefLabel[displayLang]].sort().join(" AND ") : data.prefLabel[displayLang];
        }

        const fallbackLang = (viewLang && viewLang !== defaultLang && displayLang === defaultLang)
            || (displayLang === defaultLang && (!data.prefLabel || !data.prefLabel[defaultLang]))
            || (displayLang === "und" && viewLang !== "und" && defaultLang !== "und")            
            || label === data.id;

        let title = label;

        return (
            <div style={{ minWidth: '250px' }}>
                <span className={classes.slatIcon}>
                </span>
                <SlatInner
                    show={!isReadOnly && !data.pendingDeletion && this.state.active}
                    title={title}
                    displayLang={displayLang}    
                    deprecated={data.deprecated}
                    selected={activeConcept === data.id}
                    fallbackLang={fallbackLang}
                    viewLang={viewLang}
                    titleTree={[]}
                    hasChildren={!isReadOnly}
                    onClick={(e) => onSelect(data.id, e)}
                    onActivate={() => this.setActive(true)}
                    onDeactivate={() => this.setActive(false)}>
                    <Tooltip title="Remove (but do not delete)"
                        onClick={(e) => onBreakLink()}
                        className={classes.smallIconButton}>
                        <IconButton data-test="break-link" size="small" style={{ color: 'white' }}>
                            <LinkOffIcon />
                        </IconButton>
                    </Tooltip>
                </SlatInner>
            </div >
        );
    }
}


CollectionConceptSlat.propTypes = {
    data: PropTypes.object.isRequired,
    viewLang: PropTypes.string,
    isOver: PropTypes.bool,
    position: PropTypes.number,
    activeConcept: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onBreakLink: PropTypes.func.isRequired
};

export default withRouter(withStyles(styles)(CollectionConceptSlat));